import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
    selectSearchColumns,
    selectSearchOptions,
    selectSearchSorting,
    setSearchColumns,
    setSearchSorting,
} from '../../store/slices/datagridSlice';
import {
    convertKeyToLabel,
    convertLabelToKey,
} from '../../utilities/stringHelpers';
import MoreTableSelect from './moreTableSelect';
import TableFieldsSelect from './tableFieldsSelect';
import ColumnOrderSection from './columnOrderSectionDGH';
import './datagridColumnSelectCard.css';

const DEFAULT_TABLES = ['project', 'task', 'expense', 'property', 'csi_code'];

const ColumnSelectCard = () => {
    const dispatch = useAppDispatch();
    const searchOptions = useAppSelector(selectSearchOptions);
    const selectedColumns = useAppSelector(selectSearchColumns);
    const selectedColumnSorting = useAppSelector(selectSearchSorting);
    const [visibleTables, setVisibleTables] = useState([]);
    const [moreTables, setMoreTables] = useState([]);

    useEffect(() => {
        if (Object.keys(searchOptions).length) {
            setVisibleTables(
                Object.keys(searchOptions).filter((opt) => DEFAULT_TABLES.includes(opt))
            );
            setMoreTables(
                Object.keys(searchOptions)
                    .filter((opt) => !DEFAULT_TABLES.includes(opt))
                    .map((t) => convertKeyToLabel(t))
                    .sort()
            );
        }
    }, [searchOptions]);

    const handleMoreTablesSelect = (selected) => {
        if (selected) {
            setVisibleTables([...visibleTables, convertLabelToKey(selected)]);
            const updatedMore = [...moreTables].filter((c) => c != selected).sort();
            setMoreTables(updatedMore);
        }
    };

    const handleHide = (category) => {
        setVisibleTables((cols) => cols.filter((c) => c != category));
        setMoreTables([...moreTables, convertKeyToLabel(category)].sort());
    };

    const handleColumnSelection = (category, field) => {
        const selection = `${category}.${field}`;
        const columnIndex = selectedColumns.findIndex((c) => c === selection);
        const updatedColumns = [...selectedColumns];

        if (columnIndex >= 0) {
            updatedColumns.splice(columnIndex, 1);
            const updatedColumnSorting = structuredClone(selectedColumnSorting);
            const sortIndex = selectedColumnSorting.findIndex(
                (sortCol) => Object.keys(sortCol)[0] === selection
            );
            if (sortIndex >= 0) {
                updatedColumnSorting.splice(sortIndex, 1);
                dispatch(setSearchSorting(updatedColumnSorting));
            }
        } else {
            updatedColumns.push(selection);
        }
        dispatch(setSearchColumns(updatedColumns));
    };

    return (
        <div>
            <div className="d-flex flex-wrap gap-2">
                {visibleTables.map((category) => {
                    const fieldSelections = selectedColumns.filter((c) => {
                        const [table] = c.split('.');
                        return table === category;
                    });
                    return (
                        <TableFieldsSelect
                            key={`columnselect-${category}`}
                            title={category}
                            fieldOptions={searchOptions[category]}
                            selectedFields={fieldSelections}
                            onCheck={handleColumnSelection}
                            onHide={handleHide}
                        />
                    );
                })}
                <MoreTableSelect
                    options={moreTables}
                    onSelect={handleMoreTablesSelect}
                />
            </div>

            <div className="mt-2 selectedSummary">
                {selectedColumns.length ? (
                    <ColumnOrderSection />
                ) : (
                    'No Selections'
                )}
            </div>
        </div>
    );
};

export default ColumnSelectCard;
